// extracted by mini-css-extract-plugin
export var box = "_3x-0";
export var check = "_3x-1";
export var checkboxButton = "_3x-6";
export var checkboxGroup = "_3x-5";
export var disabled = "_3x-7";
export var ghost = "_3x-9";
export var input = "_3x-2";
export var label = "_3x-4";
export var normal = "_3x-8";
export var uncheck = "_3x-3";